import _ from 'lodash';
import _v from '../vars';

_.templateSettings = { // LoDash template settings
	interpolate: /\{\{(.+?)\}\}/g,
	evaluate: /<@(.+?)@>/g
};

const _t = {

	topArticle: _.template(`<a class="pers-article-item news" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('fy-emart_vwmre', this);">
									<div class="pers-article-header">{{ title }}</div>
									<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
									<@ if (publicationDate != '') { @>
										<div class="pers-date">{{ publicationDate }}</div>
									<@ } @>
										<div class="pers-comments">
											<span class="viafoura-commentcount" data-vf-article-id="{{ uri.split('?')[0].match(/[^/-]+$/)[0] }}" data-vf-section-uuid="{{ vfUuid }}"></span>
										</div>
									</div>
									<div class="pers-article-teaser-img">
										<div class="pers-article-teaser">{{ teaser }}</div>
										<@ if (imageUrl != '') { @>
											<div class="pers-article-img-wrap"><img src="{{ imageUrl }}" class="pers-img" /></div>
										<@ } @>
										<div class="pers-card-toolbar">
											<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
											<div class="pers-share">
												<div class="pers-share-text">Share</div>
												<div class="share-layer">
													<div class="share-icon facebook"></div>
													<div class="share-icon twitter"></div>
													<div class="share-icon linkedin"></div>
													<div class="share-icon whatsapp"></div>
													<!-- <div class="share-icon email"></div> -->
												</div>
											</div>
											<div class="pers-save"><div class="pers-save-text">Save</div></div>
										</div>
									</div>
									<div class="pers-view-more-wrap">
										<div class="pers-view-more">VIEW MORE</div>
									</div>
							</a>`),

	cmeTopArticle: _.template(`<a class="pers-article-item cme" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" data-img="{{ imageUrl }}" data-credits="{{ credits }}" data-track="fy-emcme_vwmre" href="{{ uri }}">
										<div class="pers-supertitle">{{cmeTagName}}</div>
										<div class="pers-article-header">{{ title }}</div>
										<div class="pers-subheader"><div class="pers-pubname">Medscape CME & Education</div> <div class="pers-credits">{{ credits }}</div></div>
										<div class="pers-article-teaser-img">
											<div class="pers-article-teaser">{{ teaser }}</div>
											<@ if (imageUrl != '') { @>
												<div class="pers-article-img-wrap">
													<img src="{{ imageUrl }}" class="pers-img" />
												</div>
											<@ } @>
											<div class="pers-card-toolbar">
												<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
												<div class="pers-share">
													<div class="pers-share-text">Share</div>
													<div class="share-layer">
														<div class="share-icon facebook"></div>
														<div class="share-icon twitter"></div>
														<div class="share-icon linkedin"></div>
														<div class="share-icon whatsapp"></div>
														<!-- <div class="share-icon email"></div> -->
													</div>
												</div>
												<div class="pers-save"><div class="pers-save-text">Save</div></div>
											</div>
										</div>
										<div class="pers-view-more-wrap">
											<div class="pers-view-more">VIEW MORE</div>
										</div>
								</a>`),

	dpTopArticle: _.template(`<a class="pers-article-item dp data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="/viewarticle/{{contentId}}" onclick="wmdTrack('fy-embtg_vwmre', this);">
										<div class="pers-supertitle">{{ superTitle }}</div>
										<div class="pers-article-header">{{title}}</div>
										<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
										<@ if (publicationDate != '') { @>
											<div class="pers-date">{{ publicationDate }}</div>
										<@ } @>
										<div class="pers-comments">
											<span class="viafoura-commentcount" data-vf-article-id="{{ uri.split('?')[0].match(/[^/-]+$/)[0] }}" data-vf-section-uuid="{{ vfUuidDP }}"></span>
										</div>		
										<div class="video-icon"></div></div>
										<div class="pers-article-teaser-img">
											<div class="pers-article-teaser">{{ teaser }}</div>
											<@ if (imageUrl != '') { @>
												<div class="pers-article-img-wrap">
													<img src="{{ imageUrl }}" class="pers-img" />
													<span class="imgVideo">&nbsp;</span>
												</div>
											<@ } @>
											<div class="pers-card-toolbar">
												<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
												<div class="pers-share">
													<div class="pers-share-text">Share</div>
													<div class="share-layer">
														<div class="share-icon facebook"></div>
														<div class="share-icon twitter"></div>
														<div class="share-icon linkedin"></div>
														<div class="share-icon whatsapp"></div>
														<!-- <div class="share-icon email"></div> -->
													</div>
												</div>
												<div class="pers-save"><div class="pers-save-text">Save</div></div>
											</div>
										</div>
										<div class="pers-view-more-wrap">
											<div class="pers-view-more">VIEW MORE</div>
										</div>
								</a>`),

	compReportTopArticle: _.template(`<a class="pers-article-item ss comp" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('fy-emcomp_vwmre', this);">
											<div class="pers-article-header">{{ title }}</div>
											<div class="compreport-header">MEDSCAPE REPORT</div>
											<div class="pers-article-teaser-img">
												<@ if (imageUrl != '') { @>
													<div class="pers-article-img-wrap"><img src="{{ imageUrl }}" class="pers-img" /></div>
												<@ } @>
												<div class="pers-card-toolbar">
													<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
													<div class="pers-share">
														<div class="pers-share-text">Share</div>
														<div class="share-layer">
															<div class="share-icon facebook"></div>
															<div class="share-icon twitter"></div>
															<div class="share-icon linkedin"></div>
															<div class="share-icon whatsapp"></div>
															<!-- <div class="share-icon email"></div> -->
														</div>
													</div>
													<div class="pers-save"><div class="pers-save-text">Save</div></div>
												</div>
											</div>
											<div class="pers-view-more-wrap">
												<div class="pers-view-more">VIEW MORE</div>
											</div>
									</a>`),


	slideshowTopArticle: _.template(`<a class="pers-article-item ss" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('fy-emslide_vwmre', this);">
													<div class="pers-article-header">{{ title }}</div>
													<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
													<@ if (publicationDate != '') { @>
														<div class="pers-date">{{ publicationDate }}</div>
													<@ } @>
														<div class="pers-comments">
															<span class="viafoura-commentcount" data-vf-article-id="{{ uri.split('?')[0].match(/[^/-]+$/)[0] }}" data-vf-section-uuid="{{ vfUuid }}"></span>
														</div>
													</div>
													<div class="pers-article-teaser-img">
														<@ if (imageUrl != '') { @>
															<div class="pers-article-img-wrap"><img src="{{ imageUrl }}" class="pers-img" /></div>
														<@ } @>
														<div class="pers-card-toolbar">
															<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
															<div class="pers-share">
																<div class="pers-share-text">Share</div>
																<div class="share-layer">
																	<div class="share-icon facebook"></div>
																	<div class="share-icon twitter"></div>
																	<div class="share-icon linkedin"></div>
																	<div class="share-icon whatsapp"></div>
																	<!-- <div class="share-icon email"></div> -->
																</div>
															</div>
															<div class="pers-save"><div class="pers-save-text">Save</div></div>
														</div>
													</div>
													<div class="pers-view-more-wrap">
														<div class="pers-view-more">VIEW MORE</div>
													</div>
											</a>`),

	thirdPartyTopArticle: _.template(`<div class="pers-article-item thirdp" data-id="{{aspenNid}}" data-uri="{{ uri }}" data-title="{{ title }}">
													<a href="{{ uri }}" onclick="wmdPageLink('fy-emthrd_vwmre|{{aspenNid}}', this);" rel="nofollow" target="_blank" class="pers-article-link">
														<div class="pers-article-header">{{ title }}</div>
														<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
														<@ if (publicationDate != '') { @>
															<div class="pers-date">{{ publicationDate }}</div>
														<@ } @>
														</div>
														<div class="pers-article-teaser-img">
															<div class="pers-article-teaser">{{ teaser }}</div>
															<@ if (imageUrl != '') { @>
																<div class="pers-article-img-wrap"><img src="{{ imageUrl }}" class="pers-img" /></div>
																<@ if (imageCredit != '') { @>
																	<div class="pers-img-attribution img-top-article">{{ imageCredit }}</div>
																<@ } @>
															<@ } @>
														</div>
														<div class="pers-view-more-wrap">
															<div class="pers-view-more">VIEW MORE</div>
														</div>
													</a>
												</div>`),

	liveTopArticle: _.template(`<a class="pers-article-item live" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('fy-emlive_vwmre', this);">
												<div class="pers-article-item">
												<div class="pers-accredited-header"><span class="pers-accredited">ACCREDITED</span><span class="pers-live-event">LIVE EVENT</span></div>
												<div class="pers-article-header">{{ title }}</div>
												<div class="pers-article-teaser-img">
														<div class="pers-article-teaser pers-live-content">
															{{ teaser }}
														</div>
														<div class="pers-live-date">{{ liveDate }}</div>
														<div class="pers-live-location">{{ liveLocation }}</div>
														<div class="pers-faculty-wrap"><span class="pers-faculty">Faculty:</span> <span class="pers-faculty-details">{{ facultyDetails }}</span></div>
												</div>
												<div class="pers-view-more-wrap">
													<div class="pers-view-more">VIEW EVENT INFO</div>
												</div>
												</div>
								</a>`)

};

export default _t;